export const UP_USER_SOURCE = 'source';
export const UP_AUTH_TOKEN_CWT = 'auth_token';
export const UP_AUTH_TOKEN = 'token';
export const UP_AUTH_TOKEN_WELLFUNNEL = 'token_wellfunnel';
export const UP_DEV = '__dev';
export const UP_DEV_VALUE = 'aqa';
export const UP_EXPERIMENT = 'experiment';
export const UP_EXPERIMENT_VARIANT = 'experiment_variant';
export const UP_EXPERIMENT_OPTIONS = 'experiment_options';
export const UP_EXPERIMENT_IS_ENABLED = 'is_enabled';
export const UP_REF = 'ref';
export const UP_UUID = 'uuid';
export const UP_TRACK_ID = 'track-id';
export const UP_SUBSCRIPTION_ID = 'subscription_id';
export const UP_RETURN_OFFER = 'return_offer';
export const UP_UTM_SOURCE = 'utm_source';

export const SECURE_URL_PARAMS = [UP_AUTH_TOKEN, UP_AUTH_TOKEN_CWT, UP_AUTH_TOKEN_WELLFUNNEL, UP_UUID, UP_TRACK_ID];
